








import { Component, Prop, Vue } from 'vue-property-decorator';
import GSTC from 'gantt-schedule-timeline-calendar';
import 'gantt-schedule-timeline-calendar/dist/style.css';

// 以下読み込みが可能なプラグイン
import { Plugin as TimelinePointer } from 'gantt-schedule-timeline-calendar/dist/plugins/timeline-pointer.esm.min.js';
import { Plugin as ItemMovement } from 'gantt-schedule-timeline-calendar/dist/plugins/item-movement.esm.min.js';
import { Plugin as ItemResizing } from 'gantt-schedule-timeline-calendar/dist/plugins/item-resizing.esm.min.js';
import { Plugin as CalendarScroll } from 'gantt-schedule-timeline-calendar/dist/plugins/calendar-scroll.esm.min.js';
import { Plugin as HighlightWeekends } from 'gantt-schedule-timeline-calendar/dist/plugins/highlight-weekends.esm.min.js';
import { Plugin as ProgressBar } from 'gantt-schedule-timeline-calendar/dist/plugins/progress-bar.esm.min.js';
import { Plugin as Selection } from 'gantt-schedule-timeline-calendar/dist/plugins/selection.esm.min.js';
import { Plugin as TimeBookmarks } from 'gantt-schedule-timeline-calendar/dist/plugins/time-bookmarks.esm.min.js';
// 以下読み込みができないプラグイン
import { Plugin as DependencyLines } from 'gantt-schedule-timeline-calendar/dist/plugins/dependency-lines.esm.min.js';
import { Plugin as ItemTypes } from 'gantt-schedule-timeline-calendar/dist/plugins/item-types.esm.min.js';

@Component({})
export default class GanttScheduleTimelineCalendar extends Vue {
  private GSTCID = GSTC.api.GSTCID;
  private sourceID = GSTC.api.sourceID;
  private date = GSTC.api.date;
  private element: HTMLElement | null = document.getElementById('gstc');

// リストの設定
  // ガント左側の列
  private columnsFromDB = [
    {
      id: 'id',
      label: '従業員ID',
      data: ({ row }) => this.sourceID(row.id),
      sortable: ({ row }) => Number(this.sourceID(row.id)),
      width: 70,
      header: {
        content: '従業員ID',
      },
    },
    {
      id: 'name',
      data: 'name',
      sortable: 'name',
      isHTML: false,
      width: 200,
      header: {
        content: '従業員名',
      },
    }
  ];

  // ガント左側の行
  private rowsFromDB = [
    {
      id: this.GSTCID('1'),
      name: '従業員一郎'
    },
    {
      id: this.GSTCID('2'),
      name: '従業員二郎'
    },
    {
      id: this.GSTCID('3'),
      name: '従業員三郎'
    },
    {
      id: this.GSTCID('4'),
      name: '従業員四郎'
    },
    {
      id: this.GSTCID('5'),
      name: '従業員五郎'
    },
  ];

// チャートの設定
  // サンプルアイテムデータ
  @Prop({type: Array, required:true})
  public itemsFromDB!: any[];

  private calendarLevel0 = [
    {
      zoomTo: 100,
      period: 'day',
      periodIncrement: 1,
      classNames: ['gstc-date-medium gstc-date-left'],
      format({ timeStart }) {
        return timeStart.format('DD MMMM YYYY (dddd)');
      },
    }
  ];

  private calendarLevel1 = [
    {
      zoomTo: 100,
      period: 'hour',
      main: true,
      periodIncrement: 1,
      format({ timeStart }) {
        return timeStart.format('HH:mm');
      },
    }
  ];

// コンフィグ設定
  private config: Config = {
  // ライセンスキー
    licenseKey:
      '====BEGIN LICENSE KEY====\nXOfH/lnVASM6et4Co473t9jPIvhmQ/l0X3Ewog30VudX6GVkOB0n3oDx42NtADJ8HjYrhfXKSNu5EMRb5KzCLvMt/pu7xugjbvpyI1glE7Ha6E5VZwRpb4AC8T1KBF67FKAgaI7YFeOtPFROSCKrW5la38jbE5fo+q2N6wAfEti8la2ie6/7U2V+SdJPqkm/mLY/JBHdvDHoUduwe4zgqBUYLTNUgX6aKdlhpZPuHfj2SMeB/tcTJfH48rN1mgGkNkAT9ovROwI7ReLrdlHrHmJ1UwZZnAfxAC3ftIjgTEHsd/f+JrjW6t+kL6Ef1tT1eQ2DPFLJlhluTD91AsZMUg==||U2FsdGVkX1/SWWqU9YmxtM0T6Nm5mClKwqTaoF9wgZd9rNw2xs4hnY8Ilv8DZtFyNt92xym3eB6WA605N5llLm0D68EQtU9ci1rTEDopZ1ODzcqtTVSoFEloNPFSfW6LTIC9+2LSVBeeHXoLEQiLYHWihHu10Xll3KsH9iBObDACDm1PT7IV4uWvNpNeuKJc\npY3C5SG+3sHRX1aeMnHlKLhaIsOdw2IexjvMqocVpfRpX4wnsabNA0VJ3k95zUPS3vTtSegeDhwbl6j+/FZcGk9i+gAy6LuetlKuARjPYn2LH5Be3Ah+ggSBPlxf3JW9rtWNdUoFByHTcFlhzlU9HnpnBUrgcVMhCQ7SAjN9h2NMGmCr10Rn4OE0WtelNqYVig7KmENaPvFT+k2I0cYZ4KWwxxsQNKbjEAxJxrzK4HkaczCvyQbzj4Ppxx/0q+Cns44OeyWcwYD/vSaJm4Kptwpr+L4y5BoSO/WeqhSUQQ85nvOhtE0pSH/ZXYo3pqjPdQRfNm6NFeBl2lwTmZUEuw==\n====END LICENSE KEY====',

  // ガント全体の高さ
    innerHeight: 500,

  // ガントのヘッダーとカレンダーの高さ
    headerHeight: 100,

  // リストの構成
    list: {
    // ロウのデータ
      rows: GSTC.api.fromArray(this.rowsFromDB),
      row: {
        height: 40,
        gap: {
          top: 0,
          bottom: 0,
        },
      },

    // カラムの設定
      columns: {
        percent: 100,
        resizer: {
          width: 10,
          inRealTime: true,
          dots: 6,
        },
        minWidth: 50,
      // カラムのデータ
        data: GSTC.api.fromArray(this.columnsFromDB),
      },

      expander: {
        padding: 18,
        size: 20,
        icon: {
          width: 16,
          height: 16,
        },
        icons: {
          child:
            '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><ellipse ry="4" rx="4" id="svg_1" cy="12" cx="12" fill="#000000B0"/></svg>',
          open:
            '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M7.41 8.59L12 13.17l4.59-4.58L18 10l-6 6-6-6 1.41-1.41z"/><path fill="none" d="M0 0h24v24H0V0z"/></svg>',
          closed:
            '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M8.59 16.59L13.17 12 8.59 7.41 10 6l6 6-6 6-1.41-1.41z"/><path fill="none" d="M0 0h24v24H0V0z"/></svg>',
        },
      },
    // カラム表示非表示切替ボタンの設定
      toggle: {
        display: true,
        icons: {
          open:
            '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path stroke="null" d="m16.406954,16.012672l4.00393,-4.012673l-4.00393,-4.012673l1.232651,-1.232651l5.245324,5.245324l-5.245324,5.245324l-1.232651,-1.232651z"/><path stroke="null" d="m-0.343497,12.97734zm1.620144,0l11.341011,0l0,-1.954681l-11.341011,0l0,1.954681zm0,3.909362l11.341011,0l0,-1.954681l-11.341011,0l0,1.954681zm0,-9.773404l0,1.95468l11.341011,0l0,-1.95468l-11.341011,0z"/></svg>',
          close:
            '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path transform="rotate(-180 4.392796516418457,12) " stroke="null" d="m1.153809,16.012672l4.00393,-4.012673l-4.00393,-4.012673l1.232651,-1.232651l5.245324,5.245324l-5.245324,5.245324l-1.232651,-1.232651z"/><path stroke="null" d="m9.773297,12.97734zm1.620144,0l11.341011,0l0,-1.954681l-11.341011,0l0,1.954681zm0,3.909362l11.341011,0l0,-1.954681l-11.341011,0l0,1.954681zm0,-9.773404l0,1.95468l11.341011,0l0,-1.95468l-11.341011,0z"/></svg>',
        },
      },
    // ソートボタンの設定
      sort: {
        compare: null,
        icons: {
          up:
            '<svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-arrow-up"><line x1="12" y1="19" x2="12" y2="5"></line><polyline points="5 12 12 5 19 12"></polyline></svg>',
          down:
            '<svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-arrow-down"><line x1="12" y1="5" x2="12" y2="19"></line><polyline points="19 12 12 19 5 12"></polyline></svg>',
        },
      },
    },

  // チャートの構成
    chart: {
      time: {
        period: 'days',
        from: 0,
        to: 0,
        zoom: 16.5,
        leftGlobal: 0,
        rightGlobal: 0,
        levels: [],
        calculatedZoomMode: false,
        onLevelDates: [],
        onCurrentViewLevelDates: [],
        onDate: [],
        allDates: [],
      },
    // カレンダーの設定
      calendarLevels: [this.calendarLevel0, this.calendarLevel1],
      grid: {},
      item: {
        gap: {
          top: 4,
          bottom: 4,
        },
        top: 0,
        height: 30 - 3,
        minWidth: 10,
        cutIcons: {
          left:
            '<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" aria-hidden="true" focusable="false" width="1em" height="1em" style="-ms-transform: rotate(360deg); -webkit-transform: rotate(360deg); transform: rotate(360deg);" preserveAspectRatio="xMidYMid meet" viewBox="0 0 24 24"><path d="M20 9v6h-8v4.84L4.16 12L12 4.16V9h8z" fill="#ffffff"/><rect x="0" y="0" width="24" height="24" fill="rgba(0, 0, 0, 0)" /></svg>',
          right:
            '<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" aria-hidden="true" focusable="false" width="1em" height="1em" style="-ms-transform: rotate(360deg); -webkit-transform: rotate(360deg); transform: rotate(360deg);" preserveAspectRatio="xMidYMid meet" viewBox="0 0 24 24"><path d="M4 15V9h8V4.16L19.84 12L12 19.84V15H4z" fill="#ffffff"/><rect x="0" y="0" width="24" height="24" fill="rgba(0, 0, 0, 0)" /></svg>',
        },
      },
    // アイテムのデータ設定
      items: GSTC.api.fromArray(this.itemsFromDB),
      spacing: 1,
      chart: {
        calendarLevels: [this.calendarLevel0, this.calendarLevel1],
      },
    },

    slots: {
    },

    actions: {},

    plugins: [
      HighlightWeekends({
        className: 'highlighted-days'
      }),
      TimelinePointer(),
      Selection(),
      ItemResizing(),
      ItemMovement(),
      CalendarScroll(),
    // 以下プラグイン未設定の為コメントアウト
      // ProgressBar(),
      // TimeBookmarks(),
      // DependencyLines(),
    ],

  // スクロールの構成
    scroll: {
      bodyClassName: 'gstc-scrolling',
      // 水平方向
      horizontal: {
        size: 20,
        minInnerSize: 40,
        data: null,
        posPx: 0,
        maxPosPx: 0,
        area: 0,
        multiplier: 3,
        offset: 0,
        precise: false,
      },
      // 垂直方向
      vertical: {
        size: 20,
        minInnerSize: 40,
        data: null,
        posPx: 0,
        maxPosPx: 0,
        area: 0,
        multiplier: 3,
        offset: 0,
        precise: false,
      },
    },
  };

  private state = GSTC.api.stateFromConfig(this.config);

  private mounted() {
    const state = GSTC.api.stateFromConfig(this.config);
    // console.log(state)
    // state.update('config.chart.items', () => {
    //   return GSTC.api.fromArray(this.itemsFromDB)
    // })
    const element = document.getElementById('gstc');
    console.log(this.itemsFromDB)
    if (element) {
      // ガントを描画
      GSTC({
        element,
        state
      });
    }
  }
}
